import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Avatar from '@zenbusiness/zui/Avatar';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { VELO_AVATAR_SRC } from '../constants';

export function SubscriptionCancelHelp() {
  const { formatMessage } = useIntl();

  return (
    <Stack horizontal alignItems="center" gap={2}>
      <Avatar
        src={VELO_AVATAR_SRC}
        alt={formatMessage({ id: 'dashboard.subscriptionCancel.help.avatarAlt' })}
        sx={{ width: 40, height: 40 }}
      />
      <Text size="md" color="secondary">
        <FormattedMessage id="dashboard.subscriptionCancel.help.message" />
      </Text>
    </Stack>
  );
}
